<div class="treeview-item-wrapper">
  <div class="header">
    <div class="expand-btn">
      <i 
      *ngIf="hasChildren"
       class="expand mdi"       
       [ngClass]="{ 'mdi-chevron-down': showChildren, 'mdi-chevron-right': !showChildren }"
       (click)="showChildren = !showChildren"
       ></i>
    </div>
    <div
      class="item-title"
      [ngClass]="{ 'selected': isSelected }"
      (click)="select()"
    >
      {{ displayName }}
    </div>
    <ng-container *ngIf="template">
      <ng-container
        [ngTemplateOutlet]="template"
        [ngTemplateOutletContext]="{ itemKey: key }"
      ></ng-container>
    </ng-container>
  </div>
  <div class="chilrden" *ngIf="showChildren && hasChildren">
    <app-treeview-item
      *ngFor="let child of item.children"
      [getKey]="getKey"
      [getDisplayName]="getDisplayName"
      (onSelect)="onSelect.emit($event)"
      [selectedItem]="selectedItem"
      [item]="child"
      [template]="template"
    >
    </app-treeview-item>
  </div>
</div>
